module.exports = __webpack_public_path__ + "img/POSITIONING.6d70ba81.jpg";